import { customerWorkspaceReadyV1Schema, type CustomerWorkspaceReadyV1 } from "@impetusos/contracts"

export const syntheticCustomerWorkspace = (): CustomerWorkspaceReadyV1 =>
  customerWorkspaceReadyV1Schema.parse({
    state: "ready", tenantId: "0198c730-37b5-7a00-8000-000000000019",
    customerId: "45d8cd4f-b544-4cb3-82ed-b548cdd41346", version: 5,
    displayName: "Harbor Property Care", customerType: "property_manager", status: "Active",
    owningBranchId: "01944444-4444-7444-8444-444444444444", owningBranchName: "Tampa Central",
    accountOwner: "Jordan Ellis", updatedAt: "2026-07-23T00:29:00.000Z",
    contacts: [
      { contactId: "f2d6f9ae-f70f-4774-a48d-302e5f4ebb78", displayName: "Morgan Reed",
        role: "Portfolio manager", email: "morgan@example.test", phone: "+1 813 555 0142",
        isPrimary: true, estimateApprover: true },
      { contactId: "d3fd91e0-19ad-4c66-826e-07083bc851d0", displayName: "Avery Chen",
        role: "Accounts payable", email: "avery@example.test", phone: null,
        isPrimary: false, estimateApprover: false },
    ],
    locations: [
      { locationId: "0e31fc77-780d-4ba2-856f-61d80f488f52", label: "Bayview Commons",
        address: "410 Harbor Way, Tampa, FL 33602", serviceability: "confirmed", estimatable: true },
      { locationId: "996c3dd7-39a5-4e38-a49f-174433b80419", label: "Palm Court",
        address: "82 Palm Avenue, Tampa, FL 33606", serviceability: "manual_review", estimatable: false },
    ],
    branchAccess: [
      { branchId: "01944444-4444-7444-8444-444444444444", branchName: "Tampa Central",
        kind: "owner", operationalAccess: true, billingAccess: true, state: "Active" },
      { branchId: "01955555-5555-7555-8555-555555555555", branchName: "Tampa North",
        kind: "grant", operationalAccess: true, billingAccess: false, state: "Active" },
    ],
    readiness: {
      activation: [],
      estimate: [{ key: "measurement_review", severity: "blocker", title: "Verify Palm Court measurement",
        detail: "A manual property review is required before this location can be estimated.", destination: "locations" }],
      scheduling: [{ key: "access_window", severity: "warning", title: "Add service access window",
        detail: "Scheduling can continue, but crews need an access window before dispatch.", destination: "locations" }],
      invoicing: [{ key: "po_preference", severity: "warning", title: "Confirm purchase-order preference",
        detail: "The billing party has not confirmed whether a PO is required.", destination: "billing" }],
    },
    activity: [
      { activityId: "370ab86e-21a7-4b15-9ab3-a57e35048efe", occurredAt: "2026-07-23T00:28:40.000Z",
        actorDisplayName: "Jordan Ellis", action: "Portal access revoked",
        summary: "Customer portal Membership was disabled for the primary Contact.",
        correlationId: "1cea2fcb-33b6-4ce0-8e71-febbfb984b9d" },
      { activityId: "53b3235c-3e3d-4fb7-b51a-48df49743f69", occurredAt: "2026-07-23T00:10:00.000Z",
        actorDisplayName: "Jordan Ellis", action: "Customer type revised",
        summary: "Commercial profile changed to Property Manager; relationships were retained.",
        correlationId: "f4729445-214c-45e0-ad19-cf4a478cdc1d" },
    ],
  })
